import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import Icon from '@common/assets';
import { MissionType } from '@domain/constant/event/marketing/MissionType';

import classnames from 'classnames/bind';
import styles from './challenge.module.scss';
const cx = classnames.bind(styles);

const Challenge = () => {
  return (
    <div className={cx('wrap')}>
      <div className={cx('inner')}>
        <div className={cx('sectionTitleArea')}>
          <strong className={cx('sectionTitle')}>취업 JOBDA 챌린지란?</strong>
          <p className={cx('sectionDesc')}>
            어려운 자소서, 복잡한 채용과정에 지친 취준생분들을 위해
            <br />
            빠른 취업에 필요한 자료집과 다양한 혜택까지 드리는 챌린지입니다.
          </p>
        </div>

        {/* 미션 리스트 영역 */}
        <ul className={cx('missionList')}>
          <li className={cx('listItem', 'type1')}>
            <div className={cx('itemInner')}>
              <p className={cx('itemTitle')}>챌린지 참여 혜택 1</p>
              <p className={cx('itemDesc')}>
                프로필만 작성해도!
                <br />
                대기업 면접질문 연습 서비스
                <br />+ 네이버페이 2,000P 제공!
              </p>
              <ScrollLink
                to={MissionType.MISSION_1}
                offset={0}
                smooth={true}
                spy={true}
                className={cx('btnEvent', 'outLine')}
                role="button"
              >
                자세히 보기
                <Icon name="arrowUpwardLight" width={24} height={24} />
              </ScrollLink>
            </div>
          </li>

          <li className={cx('listItem', 'type2')}>
            <div className={cx('itemInner')}>
              <p className={cx('itemTitle')}>챌린지 참여 혜택 2</p>
              <p className={cx('itemDesc')}>
                역량검사만 응시해도!
                <br />
                합격자 이력서 모음집
                <br />+ 네이버페이 10,000P 제공!
              </p>
              <ScrollLink
                to={MissionType.MISSION_2}
                offset={0}
                smooth={true}
                spy={true}
                className={cx('btnEvent', 'outLine')}
                role="button"
              >
                자세히 보기
                <Icon name="arrowUpwardLight" width={24} height={24} />
              </ScrollLink>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Challenge;
